import { render, staticRenderFns } from "./Reservatorio.vue?vue&type=template&id=59de0697&scoped=true&"
import script from "./Reservatorio.vue?vue&type=script&lang=js&"
export * from "./Reservatorio.vue?vue&type=script&lang=js&"
import style0 from "./Reservatorio.vue?vue&type=style&index=0&id=59de0697&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59de0697",
  null
  
)

export default component.exports